module.exports = __webpack_public_path__ + "img/orderly.5f6bbfdb.svg";